import { mutate } from 'swr'

const normalizeGameId = (gameId: string | string[] | undefined): string | undefined =>
  Array.isArray(gameId) ? gameId[0] : gameId

const vibePointsKey = (gameId: string | string[] | undefined) => {
  const id = normalizeGameId(gameId)
  return id ? `/multi_platform/games/${id}/vibe_points` : null
}

const myVibePointsKey = (gameId: string | string[] | undefined) => {
  const id = normalizeGameId(gameId)
  return id ? `/multi_platform/games/${id}/vibe_points/me` : null
}

/** Trigger a refetch of the current user's vibe points for a given game. */
export const mutateMyVibePoints = (gameId: string | string[] | number) => {
  const id = normalizeGameId(typeof gameId === 'number' ? String(gameId) : gameId)
  if (id) mutate(myVibePointsKey(id))
}

/** Trigger a refetch of the full vibe leaderboard for a given game. */
export const mutateVibeLeaderboard = (gameId: string | string[] | number) => {
  const id = normalizeGameId(typeof gameId === 'number' ? String(gameId) : gameId)
  if (id) mutate(vibePointsKey(id))
}
